module.exports = __webpack_public_path__ + "static/img/jd_sbz.4f97c87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jd_sbz.png
// module id = l7Cx
// module chunks = 3